export * from './src/stores-catalog-v3-customization-customizations-v-3.meta.js';
